import { StyleSheet } from 'react-native';
import { pick } from 'lodash';

import { IStampHistory } from '@common/types/';

const createStyle = (attrs: IStampHistory) => {
  const finalStampItem = {
    ...attrs.shopStampItem,
    ...(attrs.attributes?.stampItem?.styles &&
      attrs.attributes.stampItem.styles),
  };

  const finalStampImprint = {
    ...attrs.shopStampImprint,
    ...(attrs.attributes?.stampImprint?.styles &&
      attrs.attributes.stampImprint.styles),
  };

  const finalStampItemWithSize = {
    ...finalStampItem,
    ...(finalStampItem.size && {
      width: finalStampItem.size.width,
      height: finalStampItem.size.height,
    }),
  };

  const finalStampImprintWithSize = {
    ...finalStampImprint,
    ...(finalStampImprint.size && {
      width: finalStampImprint.size.width,
      height: finalStampImprint.size.height,
    }),
  };

  return StyleSheet.create({
    container: {
      marginTop: attrs.marginTop,
      width: '100%',
      height: attrs.height,
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: attrs.zIndex,
    },
    stampRallyItem: {
      ...pick(attrs.stampRallyItem, [
        'height',
        'width',
        'borderWidth',
        'borderColor',
        'backgroundColor',
        'borderRadius',
      ]),
      ...(attrs.stampRallyItem?.borderStyle !== 'none' && {
        borderStyle: attrs.stampRallyItem?.borderStyle,
      }),
      alignItems: 'center',
      justifyContent: 'center',
      margin: attrs.gap / 2,
    },
    stampRallyText: {
      ...pick(attrs.stampRallyText, ['color', 'fontSize']),
      textAlign: 'center',
      fontWeight: 'bold',
    },
    shopStampItem: {
      ...pick(finalStampItemWithSize, [
        'height',
        'width',
        'borderWidth',
        'borderColor',
        'backgroundColor',
        'borderRadius',
      ]),
      ...(finalStampItemWithSize?.borderStyle !== 'none' && {
        borderStyle: finalStampItemWithSize?.borderStyle,
      }),
      alignItems: 'center',
      justifyContent: 'center',
      margin: attrs.gap / 2,
    },
    shopStampText: {
      ...pick(finalStampItemWithSize, ['color', 'fontSize']),
      textAlign: 'center',
      fontWeight: 'bold',
    },
    shopStampImprint: {
      ...pick(finalStampImprintWithSize, ['height', 'width', 'borderRadius']),
      margin: 'auto',
    },
    stampRallyImprint: {
      ...pick(attrs.stampRallyImprint, ['height', 'width', 'borderRadius']),
      margin: 'auto',
    },
  });
};

export default createStyle;
